export const colors = {
  black1: '#323c47',
  black2: '#4d6580',
  black3: '#2e3d4e',
  black4: '#222d39',
  black5: '#3c4e62',
  black6: '#243847',
  black7: '#22303F',
  blue1: '#4c7de0',
  blue2: '#214d80',
  blue3: '#2974ff',
  blue4: '#194e82',
  blue5: '#cedefd',
  blue6: '#2d80e2',
  blue7: '#e6ecf7',
  blue8: '#d7dde8',
  blue9: '#1c4b81',
  blue10: '#7595B4',
  blue11: '#2D80E2',
  gray1: '#ecf1f7',
  gray2: '#626e80',
  gray3: '#194e82',
  gray4: '#f6f8f8',
  gray5: '#8197b1',
  gray6: '#b8c4d2',
  gray7: '#f6f6f7',
  gray8: '#4a4a4a',
  gray9: '#f9f9f9',
  gray10: '#f2f4f7',
  gray11: '#74879c',
  gray12: '#ddddeb',
  gray13: '#7b8da2',
  gray14: '#424f60',
  gray15: '#e1e9f5',
  gray16: '#b3c1d2',
  gray17: '#f6f9ff',
  gray18: '#2c3c51',
  gray19: '#E9EEF2',
  gray2Shadow: '#303740',
  green1: '#10a785',
  purple1: '#395174',
  orange1: '#FFA150',
  red1: '#ff6e88',
  red2: '#ff5473',
  red3: '#f44336',
  red4: '#F04679',
  red6: '#c61148',
  turquoise1: '#1dc6d8',
  turquoise2: '#1ba1af',
  turquoise3: '#15bec5',
  turquoise4: '#59f8ff',
  turquoise5: '#71d3db',
  turquoise6: '#14f1fa',
  turquoise7: '#78d0d8',
  violet3: '#311e99',
  yellow1: '#ae8934',
  white1: '#ffffff',
};
